import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/DescriptionRounded';

class DescriptionRoundedIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default DescriptionRoundedIcon;
